<script>
    import Matrix from "../../shared/Matrix.svelte";
    import Graph from "../../shared/Graph.svelte";
    import data1 from "../../stores/Graph_L5_2.js";
    import { _ } from "svelte-i18n";

    const matrix1 = [
        [0, 0, 0, 1],
        [0, 1, 0, 0],
        [0, 0, 1, 0],
        [1, 0, 0, 0]
    ]
</script>

<div class="title">
  <h2>{$_("lesson-EFTOp.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {$_("lesson-EFTOp.p-0-0")}
    {`$$H=\\begin{bmatrix}h_a & h_{ab} & h_{ac} & h_{ad} & h_{ae} & h_{af} & h_{ag} & h_{ah} & \\cdots & h_{ap} \\\\ 0 & h_{b} & h_{bc} & h_{bd} & h_{be} & h_{bf} & h_{bg} & h_{bh} & \\cdots & h_{bp} \\\\ 0 & 0 & h_{c} & h_{cd} & h_{ce} & h_{cf} & h_{cg} & h_{ch} & \\cdots & h_{cp} \\\\ 0 & 0 & 0 & h_{d} & h_{de} & h_{df} & h_{dg} & h_{dh} & \\cdots & h_{dp} \\\\ 0 & 0 & 0 & 0 & h_{e} & h_{ef} & h_{eg} & h_{eh} & \\cdots & h_{ep} \\\\ 0 & 0 & 0 & 0 & 0 & h_{f} & h_{fg} & h_{fh} & \\cdots & h_{fp} \\\\ 0 & 0 & 0 & 0 & 0 & 0 & h_{g} & h_{gh} & \\cdots & h_{gp} \\\\ 0 & 0 & 0 & 0 & 0 & 0 & 0 & h_{h} & \\cdots & h_{hp} \\\\ \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\ddots & \\vdots \\\\ 0 & 0 & 0 & 0 & 0 & 0 & 0 & 0 & \\cdots & h_{p}\\end{bmatrix}=\\begin{bmatrix}-2 & 2 & 2 & 2 & 2 & 6.6 & 0 & 6.6 & \\cdots & 4 \\\\ 0 & -2 & 2 & 2 & 6.6 & 2 & 6.6 & 0 & \\cdots & 0 \\\\ 0 & 0 & -2 & 2 & 0 & 6.6 & 2 & 6.6 & \\cdots & 4 \\\\ 0 & 0 & 0 & -2 & 6.6 & 0 & 6.6 & 2 & \\cdots & 2 \\\\ 0 & 0 & 0 & 0 & -2 & 2 & 2 & 2 & \\cdots & 3.6 \\\\ 0 & 0 & 0 & 0 & 0 & -2 & 2 & 2 & \\cdots & 0 \\\\ 0 & 0 & 0 & 0 & 0 & 0 & -2 & 2 & \\cdots & 3.6 \\\\ 0 & 0 & 0 & 0 & 0 & 0 & 0 & -2 & \\cdots & 2 \\\\ \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\vdots & \\ddots & \\vdots \\\\ 0 & 0 & 0 & 0 & 0 & 0 & 0 & 0 & \\cdots & -2\\end{bmatrix}$$`}
    {$_("lesson-EFTOp.p-0-1")}
  </p>
  <div align="center"><img style="width: 40%" src="/img/Results.png" alt="A list of responses from the quantum annealer where each solution traverses only three cities instead of four"></div>
  <p>
    {@html $_("lesson-EFTOp.p-1-0")}
    {`$$c = \\pm \\frac{3s}{n}$$`}
    {@html $_("lesson-EFTOp.p-1-1")}
  </p>
  <div align="center"><img style="width: 25%" src="/img/Visualization.png" alt="A visualization of a 64x64 Hamiltonian where the values are represented with different colors"></div>
  <h3>{$_("lesson-EFTOp.h3-0")}</h3>
  <p>
    {@html $_("lesson-EFTOp.p-2")}
    {`$$q_A=\\left[0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0\\right]\\Rightarrow$$`}
  </p>
  <Matrix data={matrix1} size=200 showLabels={true} />
  <p>
    {@html $_("lesson-EFTOp.p-3")}
  </p>
  <Graph graph={data1} width="500" height="350" style="display: block; margin: 0 auto;"/>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
